import React, {Component} from "react";
import Head from "../../components/Head";
import Subscribe from "../../components/Subscribe";
import {withTranslate} from "react-redux-multilingual"
import globalMiddleware from "../../hocs/globalMiddleware";
import {getHeader} from "../../config";
import axios from "axios";
import {Skeleton} from "react-loading-skeleton-placeholders"
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";
import Maintenance from "../../components/Maintenance";
import {baseLink} from "../../config"


class Terms extends Component {
    state = {
        terms: null,
        error500: false,
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);

        axios.get(baseLink + "system/policies?type=1", {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                console.log("response", res);
                this.setState({
                    terms: res.data.Response,
                });
            }
        }).catch(err => {
            console.log("error", err);
            this.setState({
                error500: true,
            });
        })

    }

    render() {

        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];

        if (this.state.error500) {
            return (
                <Maintenance/>
            )
        }
        const termsList = this.state.terms ?
            (
                <div>
                    <h1>{this.state.terms.name}</h1>
                    <p dangerouslySetInnerHTML={{__html: this.state.terms.condition}}/>
                </div>
            )
            :
            (<div>
                <Skeleton amount={4} bigBone={true}/>
                <br/>
                <Skeleton amount={4} bigBone={true}/>
                <br/>
                <Skeleton amount={4} bigBone={true}/>
            </div>);

        return (
            <div className="Privacy">
                <Head title={this.props.translate("terms_title")} history={history}/>
                <section className="ftco-section doctors-list-all" id="doctors-list-all">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                {termsList}
                            </div>
                        </div>
                    </div>
                </section>

                <Subscribe/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Terms)));